import { Outlet } from "react-router-dom-v5-compat";

import styles from "features/common/paging/components/ModalJourneyWrapper/ModalWrapper.module.scss";
import RouteTransitionWrapper from "features/common/paging/components/RouteTransitionWrapper";
import LogoPageWrapper from "features/sign-up/components/LogoPageWrapper";

import { SignUpWrapper } from "./Layout";

export default function SignUpParentWrapper() {
  return (
    <LogoPageWrapper>
      <SignUpWrapper>
        <RouteTransitionWrapper className={styles.transitionWrapper}>
          <Outlet />
        </RouteTransitionWrapper>
      </SignUpWrapper>
    </LogoPageWrapper>
  );
}
